import { LogoutOutlined } from "@ant-design/icons";
import { Button, Layout } from "antd";
import { FC, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import AvatarUser from "@components/avatar-user";
import LanguageSwitcher from "@components/language-switcher";
import PageFooter from "@components/page-footer";
import PageLoader from "@components/page-loader";
import NavigationMenu from "@containers/navigation-menu";
import menuCollapsedHelper from "@helpers/menu-collapsed";
import authService from "@http/services/auth.service";
import logoCollapsed from "@static/images/leviatano-collapsed.png";
import logo from "@static/images/leviatano.png";
import { RootState } from "@store";
import { fetchCurrentUser } from "@store/effects/auth";
import { CollapseType } from "antd/lib/layout/Sider";
import classNames from "classnames";
import Image from "next/image";
import styles from "./AppLayout.module.scss";

const AppLayout: FC = ({ children }) => {
  const dispatch = useDispatch();
  const auth = useSelector((state: RootState) => state.auth);

  const [collapsed, setCollapsed] = useState<boolean>(false);

  useEffect(() => {
    if (!/iPad|iPhone|iPod|Macintosh/.test(navigator.userAgent)) {
      document.documentElement.classList.add("is-window");
    }

    dispatch(fetchCurrentUser());

    setCollapsed(menuCollapsedHelper.get());
  }, [dispatch]);

  if (auth.loading) {
    return <PageLoader />;
  }

  return (
    <Layout>
      <Layout.Sider
        width={256}
        collapsible
        breakpoint="xl"
        collapsedWidth={64}
        collapsed={collapsed}
        onCollapse={(c: boolean, type: CollapseType) => {
          if (
            type === "clickTrigger" ||
            (type === "responsive" && !collapsed)
          ) {
            setCollapsed(c);
            menuCollapsedHelper.set(c);
          }
        }}
      >
        <div className={styles.AsideContent}>
          <div>
            <div className={styles.Logo}>
              <Image
                alt="Leviatano by Opiquad"
                src={collapsed ? logoCollapsed : logo}
              />
            </div>

            <NavigationMenu />
          </div>

          <div
            className={classNames(styles.AsideFooter, {
              [styles.Collapsed]: collapsed,
            })}
          >
            <LanguageSwitcher className={styles.Btn} />

            <Button
              shape="circle"
              className={styles.Btn}
              icon={<LogoutOutlined />}
              onClick={() => authService.logout()}
            />

            <AvatarUser size="large" user={auth.currentUser} />
          </div>
        </div>
      </Layout.Sider>

      <Layout>
        <Layout.Content className={styles.Content}>{children}</Layout.Content>

        <Layout.Footer>
          <PageFooter />
        </Layout.Footer>
      </Layout>
    </Layout>
  );
};

export default AppLayout;
